import { Accordion } from "react-bootstrap";
import { Render } from "../../../../../../../../homepage/Render";
import "./StoreFaq.scss";

export const StoreFaq = (props) => {
  const { packageData } = props;
  return (
    <Render if={packageData?.length > 0}>
      <div className="faq-inner-wrapper">
        <h3>FAQ's (Frequently asked questions)</h3>
        <Accordion className="faq-accordion">
          {packageData?.map((faq, index) => (
            <Accordion.Item key={index} eventKey={index.toString()}>
              <Accordion.Header>{faq.name}</Accordion.Header>
              <Accordion.Body>{faq.description}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </Render>
  );
};
